import React from "react";
import {NavBar} from "./navbar/NavBar";
import {Route, Switch} from "react-router-dom";
import {Main} from "../pages/Main";
import {GoodPage} from "../pages/goodPage/GoodPage";
import {Reset} from "./reset/Reset";
import {Orders} from "../pages/orders/Orders";
import {OrderPage} from "../pages/orders/OrderPage";


export const Content = ({goods}) => {

    return (
        <div id='content' className="container-lg">
            <NavBar/>
            <Switch>
                <Route path="/admin" exact>
                    <Main goods={goods}/>
                </Route>
                <Route path="/admin/orders" exact>
                    <Orders/>
                </Route>
                <Route path="/admin/orders/:orderId" exact>
                    <OrderPage/>
                </Route>
                {goods.map(good => (
                    <Route key={good.link} path={'/admin' + good.link} exact>
                        <GoodPage good={good}/>
                    </Route>
                ))}
                {goods.map(good => (
                    <Route key={good.link} path={'/admin' + good.link + '/:page'} exact>
                        <GoodPage good={good}/>
                    </Route>
                ))}
            </Switch>
            <Reset />
        </div>
    )
}
